var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareEventSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share (1) 1",
    clipPath: "url(#clip0_1134_57470)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24 16C28.4183 16 32 12.4183 32 8C32 3.58172 28.4183 0 24 0C19.5817 0 16 3.58172 16 8C16 12.4183 19.5817 16 24 16Z",
    fill: "#004080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.41992 43C12.8382 43 16.4199 39.4183 16.4199 35C16.4199 30.5817 12.8382 27 8.41992 27C4.00164 27 0.419922 30.5817 0.419922 35C0.419922 39.4183 4.00164 43 8.41992 43Z",
    fill: "#004080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.88994 25.9882C5.96395 25.996 6.03832 25.9999 6.11274 26C6.60462 25.9993 7.07901 25.8174 7.44524 25.489C7.81146 25.1607 8.04383 24.7089 8.09794 24.22C8.32425 22.1453 8.95709 20.1356 9.9603 18.3056C10.9635 16.4756 12.3174 14.8612 13.9447 13.5546C14.3469 13.2177 14.6005 12.7364 14.6512 12.2143C14.7018 11.6922 14.5452 11.1712 14.2153 10.7634C13.8854 10.3556 13.4085 10.0938 12.8873 10.0343C12.3661 9.97479 11.8425 10.1224 11.4291 10.4454C9.39505 12.0792 7.70274 14.0978 6.44885 16.3858C5.19497 18.6737 4.40407 21.1863 4.12134 23.78C4.06345 24.3072 4.21719 24.8359 4.54879 25.25C4.88039 25.664 5.36275 25.9295 5.88994 25.9882Z",
    fill: "#004080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M29.3348 41.0898C25.8812 42.2968 22.1204 42.2968 18.6668 41.0898C18.1664 40.9132 17.6164 40.9425 17.1376 41.1715C16.6589 41.4004 16.2907 41.8101 16.1141 42.3105C15.9375 42.8109 15.9668 43.3609 16.1958 43.8397C16.4247 44.3184 16.8344 44.6866 17.3348 44.8632C21.6496 46.3789 26.352 46.3789 30.6668 44.8632C31.1672 44.6866 31.5769 44.3184 31.8058 43.8397C32.0348 43.3609 32.0641 42.8109 31.8875 42.3105C31.7109 41.8101 31.3427 41.4004 30.864 41.1715C30.3852 40.9425 29.8352 40.9132 29.3348 41.0898Z",
    fill: "#004080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M39.9022 24.22C39.9563 24.7089 40.1887 25.1607 40.5549 25.489C40.9211 25.8174 41.3955 25.9993 41.8874 26C41.9618 25.9999 42.0362 25.996 42.1102 25.9882C42.3714 25.9595 42.6245 25.8796 42.8548 25.7531C43.0852 25.6266 43.2883 25.4559 43.4527 25.2508C43.617 25.0457 43.7393 24.8103 43.8126 24.5579C43.8859 24.3055 43.9087 24.0412 43.8798 23.78C43.3367 18.8894 41.0062 14.3718 37.3358 11.0946C36.9398 10.7465 36.4223 10.569 35.8961 10.6005C35.3698 10.632 34.8772 10.8701 34.5256 11.2629C34.1739 11.6557 33.9915 12.1714 34.0182 12.698C34.0448 13.2245 34.2783 13.7193 34.6678 14.0746C37.6043 16.695 39.4685 20.3083 39.9022 24.22Z",
    fill: "#004080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M39.5801 43C43.9984 43 47.5801 39.4183 47.5801 35C47.5801 30.5817 43.9984 27 39.5801 27C35.1618 27 31.5801 30.5817 31.5801 35C31.5801 39.4183 35.1618 43 39.5801 43Z",
    fill: "#34A853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1134_57470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareEventSvg);
export default __webpack_public_path__ + "static/media/ShareEventSvg.6bde8f1cb842726f5b0a6047528cde5f.svg";
export { ForwardRef as ReactComponent };